// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(message_text, vehicle_category, geo_region) {
  vehicle_category !== 0;
  return {
          title_text: "ಕ್ಯಾನ್ಸಲೇಷನ್ ಸ್ಕೊರ್",
          learn_more_text: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
          info_btn_details: {
            video_url: undefined,
            question: "ಕ್ಯಾನ್ಸಲೇಷನ್ ಸ್ಕೊರ್  ಅನ್ನು ಹೇಗೆ ಲೆಕ್ಕ ಹಾಕಲಾಗುತ್ತದೆ?",
            answer: "ನೀವು ಸ್ವೀಕರಿಸಿದ ಕೊನೆಯ 30 ಆರ್ಡರ್‌ಗಳಲ್ಲಿ ಡ್ರೈವರ್‌ಗೆ ಕಾರಣವಾದ ಒಟ್ಟು ಕ್ಯಾನ್ಸಲೇಷನ್ ಗಳ ಆಧಾರದ ಮೇಲೆ ಕ್ಯಾನ್ಸಲೇಷನ್ ಸ್ಕೋರ್ ಅನ್ನು ಲೆಕ್ಕಹಾಕಲಾಗುತ್ತದೆ."
          },
          learn_more_btn_details: [
            {
              video_url: PartnerContentHelper.getV2LearnMoreVid(geo_region),
              question: "ಕ್ಯಾನ್ಸಲೇಷನ್ ಸ್ಕೊರ್  ಅಂದರೆ ಏನು ಮತ್ತು ಅದು ಏಕೆ ಮುಖ್ಯ?",
              answer: ""
            },
            {
              video_url: undefined,
              question: "ನಾನು ಯಾವಾಗ ಅಮಾನತುಗೊಳ್ಳುತ್ತೇನೆ?",
              answer: "ನೀವು ಒಂದು ಹಂತವನ್ನು ದಾಟಿದಾಗಲೆಲ್ಲಾ ನಿಮ್ಮನ್ನು ಅನುಗುಣವಾದ ಅವಧಿಗೆ ಅಮಾನತುಗೊಳಿಸಲಾಗುತ್ತದೆ."
            },
            {
              video_url: undefined,
              question: "ಪ್ರತಿ ಹಂತಗಳಿಗೆ ಅಮಾನತು ಅವಧಿ ಎಷ್ಟು?",
              answer: "ಪ್ರತಿ ಹಂತದಲ್ಲಿ ಅಮಾನತುಗೊಳಿಸುವಿಕೆಯ ಅವಧಿಯನ್ನು ಅಮಾನತು ಮಾರ್ಗದರ್ಶಿಯಲ್ಲಿ ಪರಿಶೀಲಿಸಬಹುದು."
            },
            {
              video_url: undefined,
              question: "ಕ್ಯಾನ್ಸಲೇಷನ್ ಸ್ಕೋರ್ ಅನ್ನು ನೋಡಲು ನನಗೆ ಏಕೆ ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ?",
              answer: "ಇತ್ತೀಚಿನ ತಿಂಗಳುಗಳಲ್ಲಿ ಸ್ವೀಕರಿಸಿದ ಕನಿಷ್ಠ 30 ಆರ್ಡರ್‌ಗಳನ್ನು ಹೊಂದಿರುವ ಪಾಲುದಾರರಿಗೆ ಕ್ಯಾನ್ಸಲೇಷನ್ ಸ್ಕೊರ್ ಅನ್ನು ಲೆಕ್ಕಹಾಕಲಾಗುತ್ತದೆ."
            }
          ],
          locked_score_msg: "ಕ್ಯಾನ್ಸಲೇಷನ್ ಸ್ಕೊರ್  ಅನ್ನು ಅನ್ಲಾಕ್ ಮಾಡಲು ಹೆಚ್ಚಿನ ಆರ್ಡರ್‌ಗಳನ್ನು ಸ್ವೀಕರಿಸಿ.",
          message_text: message_text,
          suspension_guide_text: "ಅಮಾನತು ಮಾರ್ಗದರ್ಶಿ",
          suspension_guide_table_details: {
            cancellation_score_text: "ಕ್ಯಾನ್ಸಲೇಷನ್ ಸ್ಕೊರ್ ",
            suspension_days_text: "ಅಮಾನತು ದಿನಗಳು"
          }
        };
}

export {
  getContent ,
  
}
/* No side effect */
